import * as z from 'zod';

import { removeHTMLTags } from 'utils/validation';

export const backgroundSchema = z.object({
  title: z.string().min(1, 'Required'),
  body: z.string().refine((val) => removeHTMLTags(val).length !== 0, {
    message: 'Required',
  }),
});

export type IBackgroundSchema = z.infer<typeof backgroundSchema>;
